function timestampForLog(log) {
  const applications = log?.applications || []
  const latestApplication = applications.reduce((latest, application) => {
    const timestamp = new Date(application.applied_at || 0).getTime()
    return timestamp > latest ? timestamp : latest
  }, 0)
  return latestApplication || new Date(log?.created_at || `${log?.worn_on || log?.wear_date || '1970-01-01'}T12:00:00`).getTime()
}

export function derivedSprayDefault(logs = [], fragranceId, fallback = 3) {
  if (!fragranceId) return fallback
  const history = logs
    .filter(log => log.fragrance_id === fragranceId)
    .sort((a, b) => timestampForLog(b) - timestampForLog(a))

  const samples = []
  for (const log of history) {
    const applications = [...(log.applications || [])]
      .sort((a, b) => new Date(b.applied_at || 0) - new Date(a.applied_at || 0))
    if (applications.length > 0) {
      applications.forEach(application => {
        const sprays = Number(application.sprays)
        if (sprays >= 1 && sprays <= 30) samples.push(sprays)
      })
    } else {
      const legacySprays = Number(log.sprays)
      if (legacySprays >= 1 && legacySprays <= 30) samples.push(legacySprays)
    }
  }
  if (samples.length === 0) return fallback

  // Use the most frequent historical value; on a tie, the most recent sample
  // wins because samples are collected newest-first.
  const counts = new Map()
  samples.forEach(value => counts.set(value, (counts.get(value) || 0) + 1))
  let best = samples[0]
  for (const value of samples) {
    if ((counts.get(value) || 0) > (counts.get(best) || 0)) best = value
  }
  return best
}

export function mostRecentGymFragranceId(logs = []) {
  const gymLogs = logs
    .filter(log => {
      const context = `${log.wear_label || ''} ${log.occasion || ''} ${log.context || ''} ${log.evening_context || ''}`.toLowerCase()
      return context.includes('gym')
    })
    .filter(log => log.fragrance_id)
    .sort((a, b) => timestampForLog(b) - timestampForLog(a))
  return gymLogs[0]?.fragrance_id || null
}
